import React from 'react';
import Header from '../../components/Header/';
import Footer from '../../components/Footer';
import Container from '../../components/Container';

const Contact = () => {
    return (
        <>
            <Header />
            <Container>
                <div>
                    <h1>Contact Us</h1>
                    <p>This is the Contact page.</p>
                </div>
            </Container>


            <Footer />
        </>
    );
};

export default Contact;
